<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6">
        <div class="pa-2">
          <v-card-title>
            รายการสินค้า
          </v-card-title>
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.item.product_code }}</td>
                <td>{{ dataDetail.item.product_name }}</td>
                <td>{{ format_number(dataDetail.item.quantity) }}</td>
                <td>{{ dataDetail.item.unit }}</td>
                <td class="pa-2">
                  <v-btn @click="getDetails(dataDetail.item.product_id)" class="pa-6 grad-success-bg white--text">
                    <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {formatNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Reduce_debt_success",
  data() {
    return {
      loading_page: false,
      search: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'รหัส',
          value: 'product_code',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          fixed: true,
          width: '150px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '120px',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    format_number: function(value) {
      return formatNumber(value)
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/inventory/reducts/reductsuccess')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.data_list = res.data.object
            }
          })
    },
    getDetails(id) {
      this.$router.push('/stock/storage/reducedebtdetailssuccess/' + id)
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>

</style>
